import React from 'react';
// import React, { useRef, useState, useEffect } from 'react';
import { Chip } from '@mui/material';
// import MaterialSymbol from '../../../components/icons/material-symbol';
// import InputEmoji from 'react-input-emoji';
import { KeywordEntry } from 'custom-type';

type ErrorMessageProps = {
  status: boolean;
  message: string;
}

type Props = {
  keywords: KeywordEntry[];
  handleSetKeywords: (keywords: KeywordEntry[]) => void;
  keywordsError: ErrorMessageProps;
  removeKeywordsError: () => void;
}

const ShowKeyword = (props: Props) => {

  return (
    <li>
      <span className='pb-3 d-inline-flex fs-14'>Set keywords and replies that will start your DM automation.</span>
      <div className='new-automation-chips'>
        {props.keywords.map((entry, index) => (
          <Chip
            key={index}
            label={`${entry.keyword} → ${entry.reply}`}
            // onDelete={() => props.handleSetKeywords(props.keywords.filter((_, i) => i !== index))}
            className='chip-item'
          />
        ))}
      </div>
    </li>
  );
};

export default ShowKeyword;